import { Button } from "@/components/ui/button";
import type { Database } from "@/types/database.types";
import { KanbanCard } from "./KanbanCard";
import { Plus } from "lucide-react";

type TaskWithDetailsRow = Database["public"]["Views"]["tasks_with_details"]["Row"];

interface KanbanColumnProps {
  title: string;
  columnStatus: "todo" | "in_progress" | "review" | "done";
  tasks: TaskWithDetailsRow[];
  onEdit: (task: TaskWithDetailsRow) => void;
  onView: (task: TaskWithDetailsRow) => void;
  onMarkComplete: (task: TaskWithDetailsRow) => void;
  onDelete: (taskId: string) => void;
  onMove: (taskId: string, toStatus: "todo" | "in_progress" | "review" | "done") => void;
  onAddTask?: (status: "todo" | "in_progress" | "review" | "done") => void;
}

export function KanbanColumn({
  title,
  columnStatus,
  tasks,
  onView,
  onMove,
  onAddTask,
}: KanbanColumnProps) {
  return (
    <div className="flex flex-col w-80 md:w-auto shrink-0">
      <div
        className="flex-1 min-h-0 bg-muted/30 rounded-lg min-w-[280px] md:min-w-0 max-h-[calc(100vh-220px)] overflow-y-auto"
        onDragOver={(e) => {
          e.preventDefault();
        }}
        onDrop={(e) => {
          e.preventDefault();
          const taskId = e.dataTransfer.getData("text/task-id");
          if (taskId) {
            onMove(taskId, columnStatus);
          }
        }}
      >
        <div className="sticky top-0 z-10 bg-muted px-4 py-4 mb-4">
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-sm">
              {title} ({tasks.length})
            </h3>
            {onAddTask && (
              <Button
                variant="ghost"
                size="sm"
                className="h-6 w-6 p-0"
                onClick={() => onAddTask(columnStatus)}
              >
                <Plus className="h-4 w-4" />
              </Button>
            )}
          </div>
        </div>
        <div className="space-y-3 px-4 pb-4">
          {tasks.map((task) => (
            <KanbanCard key={task.id} task={task} onView={onView} draggable />
          ))}
          {tasks.length === 0 && (
            <div className="text-muted-foreground text-xs py-8 text-center">No tasks</div>
          )}
        </div>
      </div>
    </div>
  );
}